/* unplugin-vue-components disabled */import script from "./m-header.vue?vue&type=script&setup=true&lang=js"
export * from "./m-header.vue?vue&type=script&setup=true&lang=js"

import "./m-header.vue?vue&type=style&index=0&id=3de5551e&lang=scss"

const __exports__ = script;

export default __exports__